export class ContainerDto {
  constructor(data) {
    this.id = data.id;
    this.price_per_collection = data.price_per_collection;
    this.free_of_charge = data.free_of_charge;
    this.pricing_details = data.pricing_details;
  }
}
